import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { EnvironmentService } from '../../service/service.module';

@Injectable({ providedIn: 'root' })
export class SeasonalityService {
  environment = EnvironmentService.environment;

  // Subjects
  public seasonalityGridActionCellSubject: Subject<any> = new Subject();
  public seasonalityManagerGridChartActionSubject: Subject<any> = new Subject();

  /* Set Subjects for HEADER COLUMN EDIT/REMOVE */
  setSeasonalityGridActionCellSubject = (value: any) => { this.seasonalityGridActionCellSubject.next(value); };
  setSeasonalityManagerGridChartActionSubject = (value: any) => { this.seasonalityManagerGridChartActionSubject.next(value); };

  // Observables
  getSeasonalityGridActionCellSubject = () => this.seasonalityGridActionCellSubject.asObservable();
  getSeasonalityManagerGridChartActionSubject = () => this.seasonalityManagerGridChartActionSubject.asObservable();

  constructor(private http: HttpClient) {
  }

  GetSeasonalityList(body: any) {
    return this.http.post(`${this.environment.SeasonalityManager}/seasonalityGetList`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  GetPendingSeasonalityList(body: any) {
    return this.http.post(`${this.environment.SeasonalityManager}/seasonalityPendingGetList`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  SeasonalityGraphDataGetList(body: any) {
    return this.http.post(`${this.environment.SeasonalityManager}/seasonalityGraphDataGetList`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  GetSeasonalityLookupList() {
    return this.http.get(`${this.environment.ForecastMapping}/GetSeasonalityLevelList`)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  GetSeasonalityById(seasonalityId: string) {
    return this.http.get(`${this.environment.SeasonalityManager}/getSeasonailtyById?seasonalityId=${seasonalityId}`)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  CreatSeaonality(body: any) {
    return this.http.post(`${this.environment.SeasonalityManager}/addSeasonality`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  UpdateSeaonality(body: any) {
    return this.http.post(`${this.environment.SeasonalityManager}/updateSeasonality`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  CopySeaonality(body: any) {
    return this.http.post(`${this.environment.SeasonalityManager}/copySeasonality`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  DeleteSeasonality(body: any) {
    return this.http.post(`${this.environment.SeasonalityManager}/deleteSeasonailty`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  UpdateSeasonalitiesStatus(body: any) {
    return this.http.post(`${this.environment.SeasonalityManager}/activate`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  ImportSeasonality(body: any) {
    return this.http.post(`${this.environment.SeasonalityManager}/importseasonality`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  GetSeasonalityGridData(body: any) {
    return this.http.post(`${this.environment.SeasonalityManager}/seasonalitysalegetlist`, body)
      .pipe(map((response: any) => {
        return response;
      }));
  }

  AdjustSeasonalityIndexValue(body: any) {
    return this.http.post(`${this.environment.SeasonalityManager}/adjustseasonalityindexvalue`, body)
      .pipe(map((response: any) => {
      return response;
    }));
  }

  ExportSeasonalityTemplate() {
    return this.http.get(
      `${this.environment.SeasonalityManager}/exportSeasonalityTemplate`).pipe(map((response: any) => {
        return response
      }));
  }

}
